import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { ValidateDate } from '../../helper';
import moment from 'moment';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faImages, faCalendarAlt } from '@fortawesome/fontawesome-free-solid';

import './eventRow.scss';

export class EventRow extends Component {
    render() {
        const {name, date, maxImages, _id, closed, sumCopies} = this.props.data;
        const status = ValidateDate.status(date, closed);

        return (
            <Link to={`/events/${_id}`} className="eRow">
                <div className="eStatus">
                    <div className={`eventStatus ${status}`}></div>
                </div>
                <div className="eCol eName">
                    {name}
                </div>
                <div className={`eCol eStartDate ${!date.start && 'missing'}`}>
                    <FontAwesomeIcon icon={faCalendarAlt}/>&nbsp;&nbsp;
                    {date.start && moment(date.start).format("HH:mm DD/MM/YY")}
                    {!date.start && "אין"}
                </div>
                <div className={`eCol eEndDate ${!date.end && 'missing'}`}>
                    <FontAwesomeIcon icon={faCalendarAlt}/>&nbsp;&nbsp;
                    {date.end && moment(date.end).format("HH:mm DD/MM/YY")}
                    {!date.end && "אין"}
                </div>
                <div className="eCol eImagesCount">
                    <FontAwesomeIcon icon={faImages}/>&nbsp;&nbsp;
                    {maxImages.event} / <span className="counter">{sumCopies}</span>
                </div>
            </Link>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/AllEventsPage/EventRow.jsx